import React, { useState, useEffect } from "react";
import { Typography, Modal as MuiModal, Card, CardContent } from "@mui/material";
import { Address } from "../../models/addressModel";
import MDBox from "mdComponents/MDBox";
import MDButton from "mdComponents/MDButton";

interface AddressPickerModalProps {
  visible: boolean;
  currentSelectedAddressId: number;
  addresses: Array<Address> | null;
  onAddressPicked: (id: number | null) => void;
  onCancel: () => void;
}

const AddressPickerModal: React.FC<AddressPickerModalProps> = ({
  visible,
  currentSelectedAddressId,
  addresses,
  onAddressPicked,
  onCancel,
}) => {
  const [selectedAddress, setSelectedAddress] = useState<number | null>(
    currentSelectedAddressId
  );

  useEffect(() => {
    setSelectedAddress(currentSelectedAddressId);
  }, [currentSelectedAddressId, visible]);

  const handleConfirm = () => {
    if(selectedAddress)
        onAddressPicked(selectedAddress);
  };

  return (
    <MuiModal open={visible} onClose={() => {}}>
      <MDBox
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: 420,
          maxWidth: "90%",
          textAlign: "center",
        }}
      >
        <Typography variant="h5" mb={1}>
          Did you mean this address?
        </Typography>
        <Typography variant="body2" mb={3}>
          Could not verify the exact address you entered.<br />Use this address?
        </Typography>

        <MDBox display="flex" flexDirection="column" gap={2}>
          {addresses?.map((addr) => {
            const isSelected = selectedAddress === addr.id;

            return (
              <Card
                key={addr.id}
                onClick={() => setSelectedAddress(addr.id)}
                sx={(theme) => ({
                  cursor: "pointer",
                  borderRadius: 2,
                  border: isSelected
                    ? `2px solid ${theme.palette.success.main}`
                    : "2px solid #e0e0e0",
                  background: isSelected
                    ? theme.palette.background.default//</MDBox>"linear-gradient(135deg, #23c2a6, #278f86)"
                    : theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  transition: "0.2s",
                  "&:hover": {
                    borderColor: theme.palette.grey,
                    transform: "scale(1.01)",
                  },
                })}
              >
                <CardContent sx={{ textAlign: "left" }}>
                  <Typography variant="body1" fontWeight="bold">
                    {addr.address}
                  </Typography>
                  <Typography variant="body2">
                    {addr.city}, {addr.state} {addr.zip}
                  </Typography>
                </CardContent>
              </Card>
            );
          })}
        </MDBox>

        <MDBox display="flex" justifyContent="flex-end" gap={2} mt={4}>
          <MDButton variant="outlined" color="secondary" onClick={onCancel}>
            Cancel
          </MDButton>
          <MDButton color="info" onClick={handleConfirm}>
            Confirm
          </MDButton>
        </MDBox>
      </MDBox>
    </MuiModal>
  );
};

export default AddressPickerModal;
